<template>
	<div class="app_detail clearfix p_background">
		<h3 class="all_title">应用审核</h3>
		<section class="app_detail_box tb_padding container_box clearfix">

			<!--应用详情头部 start-->
			<div class="details_title_box clearfix">

				<div class="photo_left inline-block">
					<!--<span class="inline-block" style="margin-left: 60px;"></span>-->
					<div class="photo_info" style="width:160px; height: 160px; border-radius:32px;">
						<div class="img_default hidden"></div>
						<img class="img_default" :src="logoPath" id="app_icon_first" alt="" />
					</div>
					<section class="form_box" style="margin-left: 26px;">
						<label class="form_label" for="">版本编号：</label>
						<span class="color_9">{{tCloudAppAuditApplicationDTO.versionno}}</span>
					</section>
					<section class="form_box" style="margin-left: 26px;">
						<a href="javascript:;" @click="checkZipByAppId">检测安装包</a>
					</section>
				</div>
				<div class="intro_right inline-block">
					<h4>{{tCloudAppAuditApplicationDTO.appname}}</h4>
					<div class="right_box clearfix">
						<section class="col-sm-6 right_box_right">
							<p>
								<span class="intro_title inline-block">申请时间：</span>
								<span class="intro_text inline-block">{{tCloudAppAuditApplicationDTO.publishtime | time}}</span>
							</p>
							<p>
								<span class="intro_title inline-block">应用分类：</span>
								<span class="intro_text inline-block" v-for="option in appTypeOptions" v-if="appCloud.businessType==option.id">{{ option.dictionaryname }}</span>
							</p>
							<p>
								<span class="intro_title inline-block">群体范围：</span>
								<span class="intro_text inline-block">{{appCloud.tcloudAppVersion.userScope}}</span>
							</p>
						</section>
						<section class="col-sm-6 right_box_right">
							<p>
								<span class="intro_title inline-block">增值服务：</span>
								<span class="intro_text inline-block">{{appCloud.tcloudAppVersion.addserviceApis}}</span>
							</p>
							<p>
								<span class="intro_title inline-block">部署类型：</span>
								<span class="intro_text inline-block">{{tCloudAppAuditApplicationDTO.deploytype}}</span>
							</p>
							<p>
								<span class="intro_title inline-block">数据接口权限：</span>
								<span class="intro_text inline-block">{{appCloud.tcloudAppVersion.misdataApis}}</span>
							</p>
						</section>
					</div>
					<div class="developer">
						<p>
							<span class="intro_title inline-block">开发者：</span>
							<span class="intro_text inline-block">{{tCloudAppAuditApplicationDTO.uploaduser}}</span>
						</p>
					</div>
					<!-- right_box/ -->
				</div>
			</div>
			<!-- details_title_box/ -->
			<!--应用详情头部 end-->

			<!--应用简介 start-->
			<div class="details_presentation_box word-bw">
				<h5 class="ht5">应用介绍：</h5>
				<p class="color_9">{{tCloudAppAuditApplicationDTO.appcomment}}</p>
			</div>
			<!--应用简介 end-->

			<!--应用价格 start-->
			<div class="details_presentation_box word-bw">
				<h5 class="ht5">应用价格：</h5>
				<section class="add_list clearfix">
				<table class="table table_dashed" v-if="addLists.length>0">
					<tbody>
						<tr v-for="(addList,index) in addLists">
							<td>
								<span class="color_6">单套价格（人民币）：</span>
								<span class="color_9 addList_money" v-if="!costFlag">{{addList.money}} 元</span>
								<input type="text" class="form-control width_auto form_control addList_money" v-else :disabled="hidsubv" name="" maxlength="12" :id="'addList_money'+index" v-model="addList.money" />
							</td>
							<td>
								<span class="color_6">服务期限：</span>
								<span class="color_9 addList_timeLimit" v-if="!costFlag">{{addList.timeLimitValue}}</span>
								<input type="hidden" :id="'addList_timeLimit'+index" class="addList_timeLimit" :value="addList.timeLimit" />
								<!--<input type="text" class="form-control width_auto form_control" v-else name="" id="" :value="item.timeLimit" />-->
								<select class="form-control form_control" v-model="addList.timeLimit" :disabled="hidsubv" v-if="costFlag">
									<option value="">请选择服务期限</option>
									<option value="1">1个月</option>
									<option value="12">1年</option>
									<option value="9999">无期限</option>
								</select>
							</td>
							<td>
								<span class="color_6">套数区间：</span>
								<span class="color_9 addList_minNum addList_maxNum" v-if="!costFlag">{{addList.minNum}} ~ {{addList.maxNum}} 套</span>
								<span class="suit" v-else>
									<input type="text" class="form-control form_control addList_minNum" name="" :disabled="hidsubv" :id="'addList_minNum'+index" maxlength="10" value="" v-model="addList.minNum"/>
									~
									<input type="text" class="form-control form_control addList_maxNum" name="" :disabled="hidsubv" :id="'addList_maxNum'+index" maxlength="10" value="" v-model="addList.maxNum"/>
								</span>
							</td>
						</tr>
					</tbody>
				</table>
			</section>
			</div>
			<!--应用价格 end-->

			<!--版本更新说明 start-->
			<div class="details_presentation_box word-bw">
				<h5 class="ht5">版本更新说明：</h5>
				<p class="color_9">{{tCloudAppAuditApplicationDTO.versioncomment}}</p>
				<div class="details_presentation_box" style="width: auto;">
					<section class="line_block">
						<h5 class="ht5">历史版本：</h5>
						<a href="javascript:;" class="cursor verson">查看历史版本</a>
					</section>

					<div class="dd" id="versions" style="margin: 10;display: none;">
						<thead>
							<tr>
								<td style="width: 120px;">
									应用名称
								</td>
								<td style="width: 120px;">
									应用版本
								</td>
								<td style="width: 150px;">
									发布时间
								</td>
							</tr>
						</thead>
						<tbody>
							<tr v-for="listVersion in tCloudAppVersionList">
								<td>{{listVersion.appname}}</td>
								<td>{{listVersion.versionno}}</td>
								<td>{{listVersion.publishtime?listVersion.publishtime:''|time}}</td>
							</tr>
						</tbody>

					</div>
				</div>

			</div>
			<!--版本更新说明 end-->

			<!--应用截图 start-->

			<div class="details_screenshot_box">
				<h5 class="ht5">屏幕截图：</h5>
				<el-carousel :interval="4000" type="card" height="300px">
					<el-carousel-item v-for="(pic,index) in appCloudFiles" :key="pic.appCloudFiles">
						<div class="item">
							<img :src="pic.filePath">
						</div>
					</el-carousel-item>
				</el-carousel>
			</div>

			<!--应用截图 end-->

			<!--审核记录 start-->
			<div class="details_record_box">
				<h5 class="ht5">审核记录：</h5>
				<section v-if="tCloudAppInspectList.length > 0">
					<!--<el-collapse v-model="activeName" accordion>
						<el-collapse-item  v-for="(audit,index) in tCloudAppInspectList" name="index" :key="audit.tCloudAppInspectList" :title="audit.inputTime?audit.inputTime:''|time" >
							<div>{{audit.inputUser}}【{{audit.appname}} {{audit.versionno}}】</div>
							<div>
								<span class="state state_not" v-if="audit.inspectStatus == '2'">不通过</span>
								<span class="state state_success" v-if="audit.inspectStatus == '1'">通过</span>
							</div>
							<div>{{audit.inspectComment}}</div>
						</el-collapse-item>
					</el-collapse>-->
					<p class="color_9 line_block" v-for="audit in tCloudAppInspectList">
						<span class="time text-space">{{audit.inputTime | time}}</span>
						<span class="name text-space" data-toggle="tooltip" data-placement="bottom" title="管理员【名称v.1.0.1】">管理员【{{audit.inputUser}} {{audit.versionno}}】</span>
						<span class="state state_not" v-if="audit.inspectStatus == '2'">不通过</span>
						<span class="state state_success" v-if="audit.inspectStatus == '1'">通过</span>
						<span class="text text-space" data-toggle="tooltip" data-placement="bottom" :title="audit.inspectComment">
							{{audit.inspectComment}}
						</span>
					</p>
				</section>
				<section v-else>
					<p class="color_9">&nbsp;&nbsp;&nbsp;&nbsp;暂无审核记录</p>
				</section>
			</div>

			<!--审核记录 end-->

			<div class="details_record_box" id="review_inspect">
				<h5 class="ht5">审核意见：</h5>
				<textarea style="width: 100%;" rows="8" v-model="tCloudAppInspect.inspectComment" id="myArea" maxlength="250"></textarea>
			</div>
			<div class="btn_box text-center partition_message">
				<span class="btn btn_submit" @click="doSubmit(1)" id="review_yes">审核通过</span>
				<span class="btn btn_submit" @click="doSubmit(2)" id="review_no">审核不通过</span>
			</div>

		</section>

	</div>
</template>

<script>
	import { MessageBox } from 'element-ui'
	export default {
		name: 'review_app',
		data() {
			return {
				appId: '',
				versionId: '',
				editFlag: '',
				appTypeOptions: '',
				appCloudFiles: '',
				appRange: '',
				appAddServices: '',
				appInterface: '',
				tCloudApp: '',
				appCloud: {
					id: '',
					appName: '',
					appEnName: '',
					appType: '',
					businessType: '',
					deployType: '',
					appClinetid: '',
					appClinetsercet: '',
					appversionid: '',
					uploadUser: '',
					specialType: '',
					delFlag: '',
					authCode: '',
					authType: '',
					inputTime: '',
					inputUser: '',
					updateTime: '',
					updateUser: '',
					tcloudAppVersion: {
						id: '',
						appid: '',
						versionNo: '',
						appComment: '',
						appInstallpackagePath: '',
						versionComment: '',
						publishTime: '',
						misdataApis: '',
						addserviceApis: '',
						visitUrl: '',
						userScope: '',
						inspectStatus: '',
						publishStatus: '',
						delFlag: '',
						inputTime: '',
						inputUser: '',
						updateTime: '',
						updateUser: '',
						publishType: '',
					}
				},
				appVersionAuditList: '',
				tCloudAppVersionList: '',
				tCloudAppInspectList: [],
				tCloudAppInspect: {
					inspectComment: '',
					inspectStatus: ''
				},
				tCloudAppAuditApplicationDTO: '',
				logoPath: '',
				addLists: [],
				costFlag: true
			}
		},
		//初始化页面
		created: function() {
			var $this = this;
			this.appId = this.$route.params.appid;
			this.versionId = this.$route.params.versionId;
			this.editFlag = this.$route.params.editFlag;
			this.getSystemConfigList();
			//查询审核描述
			this.getCloudAppInspect();
			this.getApplicationInfo();
			this.findVersionList();
			$this.getAuditRecords();
			//获取价格集合
			this.getPriceList();
			//查询应用详细信息
			this.getAppCloudDetial(function() {
				//查询附件
				$this.getAppCloudFiles();
				//查询版本审核详情
				$this.getAppVersionAuditList();
				$this.loadLogo();
			});
		},
		mounted: function() {
			this.$nextTick(function() {
				var flagg = this.editFlag;
				if(flagg == 1) {
					document.getElementById('myArea').readOnly = true;
					//							$(".btn_submit").attr("disabled","disabled");
					$(".partition_message").css("display", "none");
					$("#review_inspect").css("display", "none");
				}

				$(function() {
					$('.verson').click(function() {
						var dd = $(this).parent().siblings('.dd');
						if(dd.css('display') == 'none') {
							dd.show(500)
						} else {
							dd.hide(500);
						}

					});
				});
			})
		},
		methods: {
			getApplicationInfo() {
				var temp = this;
				var aapId = this.appId;
				var versionId = this.versionId;
				this.$http.post('/zklccloud/auditApplication', {
					"appId": aapId,
					"versionId": versionId
				}, {
					emulateJSON: true
				}).then(function(m) {
					temp.tCloudAppAuditApplicationDTO = m.body.content.tCloudAppAudit;
				})
			},
			findVersionList() {
				var temp = this;
				var aapId = this.appId;
				this.$http.post('/zklccloud/findVersionList', {
					"appId": aapId
				}, {
					emulateJSON: true
				}).then(function(m) {
					temp.tCloudAppVersionList = m.body;
				})
			},
			getSystemConfigList() {
				var temp = this;
				this.$http.post('/zklccloud/queryAllTCloudSysDictionary', {
					emulateJSON: true
				}).then(function(m) {
					for(var key in m.body.dictionaryMap) {
						if(key == '应用分类') {
							temp.appTypeOptions = m.body.dictionaryMap[key];
						} else if(key == '群体范围') {
							temp.appRange = m.body.dictionaryMap[key];
						}
						/*else if(key == '增值服务')
						{
							temp.appAddServices = m.body.dictionaryMap[key];
						}
						else if(key == '数据接口权限')
						{
							temp.appInterface = m.body.dictionaryMap[key];
						}*/
					}
				})
			},
			getAuditRecords() {
				var temp = this;
				var aapId = this.appId;
				this.$http.post('/zklccloud/findAuditRecords', {
					"appId": aapId
				}, {
					emulateJSON: true
				}).then(function(m) {
					temp.tCloudAppInspectList = m.body;
				})
			},
			getCloudAppInspect() {
				var temp = this;
				var aapId = this.appId;
				var versionId = this.versionId;
				this.$http.post('/zklccloud/findAppInspect', {
					"appId": aapId,
					"appversionNo": versionId
				}, {
					emulateJSON: true
				}).then(function(m) {
					temp.tCloudAppInspect = m.body.content.tCloudAppInspect;
					temp.tCloudAppInspect.inspectComment = "";
				})
			},
			getAppCloudDetial(callback) {
				var temp = this;
				var aapId = this.appId;
				this.$http.post('/zklccloud/findTCloudAppById', {
					"appid": aapId
				}, {
					emulateJSON: true
				}).then(function(m) {
					temp.appCloud = m.body.content.tCloudApp
					if(callback) {
						callback();
					}

				})
			},
			getAppCloudFiles() {
				var temp = this;
				this.$http.post('/zklccloud/findTCloudAppFilesById', {
					"appversionid": this.appCloud.appversionid
				}, {
					emulateJSON: true
				}).then(function(m) {
					temp.appCloudFiles = m.body.content.appFiles
				})
			},
			getAppVersionAuditList() {
				var temp = this;
				var aapId = this.appId;
				this.$http.post('/zklccloud/auditApplication', {
					"appId": aapId
				}, {
					emulateJSON: true
				}).then(function(m) {
					temp.appVersionAuditList = m.body
				})
			},
			loadLogo() {
				var temp = this;
				this.$http.post('/zklccloud/apps/toGetAppImagePath', {
					"appVersionId": this.appCloud.appversionid,
					"fileType": '108001'
				}, {
					emulateJSON: true
				}).then(function(m) {
					temp.logoPath = m.body.data
				})
			},
			//检查zip包是否异常
			checkZipByAppId(){
				var formData = {"appId":this.appId,"version":this.versionId};
				this.$http.post('/zklccloud/checkZipByAppId', formData, {emulateJSON: true}).then(function(m) {
					var checkInfo = m.body.content.checkInfo;
					if(checkInfo.length>0){//集合大于零表示安装包有异常
						var errorInfos = "";
						var indexInfo = 1;
						for(var i=0;i<checkInfo.length;i++){
							if(checkInfo[i].status=="0"){
								errorInfos = indexInfo +"、"+checkInfo[i].checkItem;
								indexInfo++;
							}
						}
						MessageBox(errorInfos, '安装包异常提示', 'warning', {
							confirmButtonText: '确定',
						}).then(() => {
						});
					}else{
            MessageBox('安装包格式正确', '提示', 'success', {
              confirmButtonText: '确定',
            }).then(() => {
            });
          }
			})
			},
			doSubmit(is) {
				var temp = this;
				var myArea = $("#myArea").val();
				if(myArea == '' || null == myArea) {
					MessageBox('请填写审核意见', '提示', 'warning', {
						confirmButtonText: '确定',
					});
					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return false;
				}
				temp.submitAudit(is);//提交审核
			},
			//提交后台审核
			submitAudit(is){
				var temp = this;
				this.tCloudAppInspect.inspectStatus = is;
				this.tCloudAppInspect.appid = this.appId;
				var formData = JSON.stringify(this.tCloudAppInspect);
				this.$http.post('/zklccloud/submitAudit', formData, {emulateJSON: true}).then(function(m) {
					//alert("操作成功！");
					var ret = m.body;
					var flag = m.body.resultCode;
					if(flag == '0'){
						MessageBox('操作成功！', '提示', 'success', {
							confirmButtonText: '确定',
						}).then(() => {
							temp.$router.push({name: 'manage_app'});
						});
						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
					}else{
						MessageBox('操作失败，请联系管理员！', '提示', 'warning', {
							confirmButtonText: '确定',
						}).then(() => {
							this.$router.push({name: 'manage_app'});
							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
						})
					}
				})
			},
			getPriceList(){
				var temp = this;
				if(null == temp.appId || '' == temp.appId || 'undefined' == temp.appId) {
					return false;
				}
				this.$http.post('/zklccloud/findPriceListByAppId', {
					"appId": temp.appId
				}, {
					emulateJSON: true
				}).then(function(m) {
					if(m.body.resultCode == '0') {
						if('' == m.body.content.priceList){
							temp.addLists = [];
						}else{
							temp.costFlag = false;
							temp.addLists = m.body.content.priceList;
						}
					}
				})
			}
		}
	}
</script>
<style>
	#app_icon_first {
		width: 160px;
		height: 160px;
		border-radius: 32px;
	}

	.developer {
		padding: 0 15px;
	}

	.details_record_box {
		margin-bottom: 15px;
	}
</style>



// WEBPACK FOOTER //
// review_app.vue?6f5c1c3f